<div class="width-lg max-width-xl" *ngIf="bir?.code && !bir.code.startsWith('COMPANY_PROFILE')">
  <div>
    <strong>{{ bir.code }}</strong>
  </div>
  <div>
    <small>{{ name }}</small>
  </div>
  <div>
    <small>{{ tin }}</small>
  </div>
  <nz-divider class="m-none"></nz-divider>
</div>
